import { useEffect } from 'react'
import {getUsersLEBU} from '../../../services/Auth/user.service'
import { treeify } from '../../../common/Helpers'

const useGetUsers = (legal_entity_id, bu_id, userList, setUserList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getUsersLEBU(legal_entity_id, bu_id);

                const response = serviceResponse.data;
                if (response.succeeded) {
                    let response_aux = treeify(response.data !== null ? response.data : [], 'userName', null, 'children', "fullName", "emailUser")

                    for (let index = 0; index < response_aux.length; index++) {
                        const element = response_aux[index];
                        element.checked = false;
                        element.username = response_aux[index].userName.indexOf('\\') > 0 ? response_aux[index].userName.split('\\')[1] : response_aux[index].userName;
                    }
    
                    setUserList(response_aux);
                }
                else {
                    setUserList([]);
                }
            }
            catch (error) {
                setUserList([]);
            }
        }
        
        if ((legal_entity_id || bu_id) && userList === null) {
            getData()
        }
    }, [legal_entity_id, bu_id, userList, setUserList]);
}


export {
    useGetUsers
}